import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateUser,
  withTextLocalizer,
  LocalizePropType,
  selectUser,
  getNextUserOpenChallengeRoute,
} from 'getaway-data-layer';
import {
  GA_TITLES,
  isDashboardScreen,
  navigateTo,
  reportGAEvent,
} from '../../../../utils';
import AddPinView from './AddPinView';
import { showAlert } from 'getaway-data-layer/src/helpers/showAlert';

type Props = {
  localize: LocalizePropType;
};

const AddPinContainer = ({ localize }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);

  const onSuccess = (updatedUser = user) => {
    navigateTo(history, getNextUserOpenChallengeRoute(updatedUser));
    reportGAEvent(GA_TITLES.ON_BOARDING.PIN_SUBMITTED);
  };

  const onSubmit = (pin: string) => {
    dispatch(updateUser({ pin: pin.trim() }, onSuccess));
  };

  const onClose = () => {
    if (isDashboardScreen()) {
      navigateTo(history, '/settings');
    } else {
      showAlert(
        '',
        localize('cancel.FirstSteps.dialog.message'),
        localize('cancel.FirstSteps.dialog.yes'),
        () => navigateTo(history, '/settings'),
        localize('cancel.FirstSteps.dialog.no'),
        () => {},
        true
      );
    }
  };

  return (
    <AddPinView localize={localize} onClose={onClose} onSubmit={onSubmit} />
  );
};

export default withTextLocalizer(AddPinContainer);
